import React from 'react'

import Card from 'components/common/Card'

type PaneProps = {
  title?: React.ReactNode
  actions?: React.ReactNode
  children?: React.ReactNode
  className?: string
}

const Pane = ({ title = '', actions, children, className }: PaneProps) => (
  <Card className={className}>
    {title && <h1>{title}</h1>}
    {actions}
    {children && <main>{children}</main>}
  </Card>
)
export default Pane
